/** @jsx h */
import { labels } from '../config';
import { Fragment } from 'preact';

const ResultTitle = ({ allResultCount }) => {
  return (
    <p className="is-text-l" aria-live="polite">
      {allResultCount === 1 ? (
        labels.results.foundSingular
      ) : (
        <Fragment>
          {labels.results.found &&
            labels.results.found.replace('@resultsTotal', allResultCount)}
        </Fragment>
      )}
    </p>
  );
};

export default ResultTitle;
